import { MessageCircle, ShoppingBag } from "lucide-react";
import { WHATSAPP_NUMBER, STORE_HOURS } from "../data/menu";
import { UserMenu } from "./UserMenu";

const NAV = [
  { label: "Monte seu copo", target: "#monte", testId: "nav-builder" },
  { label: "Roleta", target: "#roleta", testId: "nav-roleta" },
  { label: "Promoções", target: "#promos", testId: "nav-promos" },
  { label: "Sorvetes", target: "#sorvetes", testId: "nav-extras" },
  { label: "A loja", target: "#loja", testId: "nav-store" },
];

export const Header = ({ cartCount, onCartOpen, onNavigate, onAdminOpen }) => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-purple-500/20 bg-[#1E053B]/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
      <button
        type="button"
        data-testid="header-logo"
        onClick={() => onNavigate("#topo")}
        className="font-syne text-xl font-extrabold tracking-tight text-white"
      >
        GIGA<span className="text-[#A855F7]">AÇAÍ</span>
      </button>

      <nav className="hidden items-center gap-7 lg:flex">
        {NAV.map((n) => (
          <a
            key={n.target}
            href={n.target}
            data-testid={n.testId}
            onClick={(e) => {
              e.preventDefault();
              onNavigate(n.target);
            }}
            className="font-grotesk text-xs font-bold uppercase tracking-[0.2em] text-purple-200/80 transition-colors duration-200 hover:text-amber-300"
          >
            {n.label}
          </a>
        ))}
      </nav>

      <div className="flex items-center gap-2.5">
        <span
          data-testid="header-status-pill"
          className="hidden items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3.5 py-1.5 text-xs font-semibold text-emerald-300 sm:flex"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
          </span>
          {STORE_HOURS}
        </span>

        <a
          data-testid="header-whatsapp-button"
          href={`https://wa.me/${WHATSAPP_NUMBER}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp da loja"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-purple-500/30 bg-white/5 text-purple-100 transition-colors duration-200 hover:border-emerald-400/60 hover:text-emerald-300"
        >
          <MessageCircle className="h-4.5 w-4.5" />
        </a>

        <UserMenu onAdminOpen={onAdminOpen} />

        <button
          type="button"
          data-testid="header-cart-button"
          onClick={onCartOpen}
          aria-label="Ver pedido"
          className="relative flex h-10 w-10 items-center justify-center rounded-full bg-emerald-400 text-[#1E053B] transition-transform duration-200 hover:scale-105"
        >
          <ShoppingBag className="h-4.5 w-4.5" strokeWidth={2.4} />
          {cartCount > 0 && (
            <span
              data-testid="header-cart-badge"
              className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-400 px-1 text-[11px] font-extrabold text-[#1E053B]"
            >
              {cartCount}
            </span>
          )}
        </button>
      </div>
    </div>

    <nav className="mx-auto flex w-full max-w-7xl gap-2 overflow-x-auto px-4 pb-3 [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden">
      {NAV.map((n) => (
        <a
          key={n.target}
          href={n.target}
          data-testid={`${n.testId}-mobile`}
          onClick={(e) => {
            e.preventDefault();
            onNavigate(n.target);
          }}
          className="shrink-0 rounded-full border border-purple-500/25 bg-white/5 px-4 py-2 font-grotesk text-[11px] font-bold uppercase tracking-[0.15em] text-purple-100 transition-colors duration-200 active:bg-white/15"
        >
          {n.label}
        </a>
      ))}
    </nav>
  </header>
);
